import axios from "../../axios/ctiConfig";
import ctiRequest from "../../axios/ctiRequests";
import * as actionTypes from "./actionTypes";
import { localStorageFunc, notify } from "../../helpers/utility";

export const getCustomerDetailsStart = () => {
	return {
		type: actionTypes.GET_CUSTOMER_DETAILS_START,
	};
};

export const getCustomerDetailsFail = (error) => {
	return {
		type: actionTypes.GET_CUSTOMER_DETAILS_FAIL,
		error: error,
	};
};

export const getCustomerDetailsSuccess = (agentId, campaignId, leadId, crmFields, crmValues, leadType) => {
	return {
		type: actionTypes.GET_CUSTOMER_DETAILS_SUCCESS,
		crmFields: crmFields,
		crmValues: crmValues,
		leadType: leadType,
		leadId: leadId,
		campaignId: campaignId,
	};
};

export const getCustomerDetails = (agentId, campaignId, leadId, leadType) => {
	return (dispatch) => {
		dispatch(getCustomerDetailsStart());
		ctiRequest["CTI_GET_CUST_FIELDS"].agent_id = agentId;
		ctiRequest["CTI_GET_CUST_FIELDS"].lead_id = leadId;
		ctiRequest["CTI_GET_CUST_FIELDS"].campaign_id = campaignId;
		ctiRequest["CTI_GET_CUST_FIELDS"].ip = localStorageFunc.get("clientIP");
		axios
			.post("/", ctiRequest["CTI_GET_CUST_FIELDS"])
			.then((result) => {
				const res = result.data.response;
			
				if (res.status === "SUCCESS") {
					
					const crmFields = res.crm_fields ?? res.basic_fields;
					const crmValues = res.crm_values ?? res.basic_values;
			
					dispatch(getCustomerDetailsSuccess(agentId, campaignId, leadId, crmFields, crmValues, leadType));
					
					if (window.bcScriptFunction) {
						window.bcScriptFunction();
					}
				} else {
					dispatch(getCustomerDetailsFail(res.reason));
				}
			})
			.catch((err) => {
				notify("CRM Error", "call-crm");
				dispatch(getCustomerDetailsFail(err));
			});
	};
};

//2. CRM Update
export const customerDetailsStart = () => {
	return {
		type: actionTypes.CUSTOMER_DETAILS_START,
	};
};

export const customerDetailsFail = (error) => {
	return {
		type: actionTypes.CUSTOMER_DETAILS_FAIL,
		error: error,
	};
};

export const customerDetailsSuccess = (agentId) => {
	return {
		type: actionTypes.CUSTOMER_DETAILS_SUCCESS,
	};
};

export const customerDetails = (agentId, campaignId, leadId, setValues, oldValues) => {
	return (dispatch) => {
		dispatch(customerDetailsStart());
		ctiRequest["CTI_CRM_UPDATE"].agent_id = agentId;
		ctiRequest["CTI_CRM_UPDATE"].lead_id = leadId;
		ctiRequest["CTI_CRM_UPDATE"].campaign_id = campaignId;
		ctiRequest["CTI_CRM_UPDATE"].ip = localStorageFunc.get("clientIP");
		ctiRequest["CTI_CRM_UPDATE"].changed_phone_field = oldValues
		for (const [key] of Object.entries(ctiRequest["CTI_CRM_UPDATE"])) {
			if (key !== "agent_id" && key !== "campaign_id" && key !== "lead_id" && key !== "ip" && key !== "resFormat" && key !== "transaction_id" && key !=="changed_phone_field") {
				//console.log(key);
				delete ctiRequest["CTI_CRM_UPDATE"][key];
			}
		}
		//console.log(setValues);
		if (Object.keys(setValues).length > 0) {
			for (const [key, value] of Object.entries(setValues)) {
				//console.log(key, value);
				ctiRequest["CTI_CRM_UPDATE"][key] = value;
			}
			axios
				.post("/", ctiRequest["CTI_CRM_UPDATE"])
				.then((result) => {
					if (result.data.response.status === "SUCCESS") {
						notify("CRM successfully Updated", "set-crm", "success");
						dispatch(customerDetailsSuccess(agentId));
					} else {
						notify("CRM Error: " + result.data.response.reason, "set-crm");
						dispatch(customerDetailsFail(result.data.response.reason));
					}
				})
				.catch((err) => {
					console.log(err);
					notify("CRM Error", "set-crm");
					dispatch(customerDetailsFail(err));
				});
		} else {
			notify("No CRM data to update", "set-crm");
			dispatch(customerDetailsFail("No data to update"));
		}
	};
};

export const createCustomerStart = () => {
	return {
		type: actionTypes.CREATE_CUSTOMER_START,
	};
};

export const createCustomerFail = (error) => {
	return {
		type: actionTypes.CREATE_CUSTOMER_FAIL,
		error: error,
	};
};

export const createCustomerSuccess = (agentId, leadId) => {
	return {
		type: actionTypes.CREATE_CUSTOMER_SUCCESS,
		leadId: leadId,
	};
};

export const resetCustomerDetails = () => {
  return {
    type: actionTypes.RESET_CUSTOMER_DETAILS,
  };
};

export const createCustomer = (agentId, phone, listId) => {
	return (dispatch) => {
		dispatch(createCustomerStart());
		ctiRequest["CTI_ADD_CUSTOMER"].agent_id = agentId;
		ctiRequest["CTI_ADD_CUSTOMER"].list_id = listId;
		ctiRequest["CTI_ADD_CUSTOMER"].phone_num = phone;
		ctiRequest["CTI_ADD_CUSTOMER"].ip = localStorageFunc.get("clientIP");
		axios
			.post("/", ctiRequest["CTI_ADD_CUSTOMER"])
			.then((result) => {
				//alert(result.data.response.lead_id);
				if (result.data.response.status === "SUCCESS") {
					dispatch(createCustomerSuccess(agentId, result.data.response.lead_id));
				} else {
					notify("Add Customer Error: " + result.data.response.reason, "call-crm");
					dispatch(createCustomerFail(result.data.response.reason));
				}
			})
			.catch((err) => {
				console.log(err);
				notify(err, "call-crm");
				dispatch(createCustomerFail(err));
			});
	};
};
